import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator'
import TradeItem from './TradeItem'
import { useSharedState } from '../waxplorer/Waxplorer'
import { useTranslation } from 'react-i18next'

const ReceivedTrades = (props) => {
    const tabKey = props['tabKey']

    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : values['user']

    const [trades, setTrades] = useState(null)

    const loadReceivedTrades = async (userName) => {
        get(`get-received-trade-offers/${userName}?verified=${true}`).then(
            (res) => {
                setTrades(res)
            },
        )
    }

    useEffect(() => {
        if (tabKey === 'received-offers' && userName) {
            loadReceivedTrades(userName)
        }
    }, [tabKey, userName])

    const { t } = useTranslation('common')

    return trades ? (
        <div className="w-full relative h-9/10">
            {trades && trades.length > 0
                ? trades.map((trade) => <TradeItem trade={trade} />)
                : t('trading.no_trade_offers_found')}
        </div>
    ) : (
        <LoadingIndicator />
    )
}

export default ReceivedTrades
